import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Form, InputGroup } from 'react-bootstrap';

import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';

const VideoGoProLogFileField = ({
  coordinatesDataType,
  logFileName,
  loadCSVGoProFile,
  toggleButtonSwitch,
  isAutoLoadData
}) => {
  if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.CSV_GO_PRO) {
    return (
      <>
        {!isAutoLoadData && (
          <Form.Group>
            <Form.Label>Log File</Form.Label>
            <InputGroup>
              <Form.Label className="custom-file-label col-12" htmlFor="csvGoPrLogFileName">
                {!isEmpty(logFileName) ? logFileName : 'Upload File'}
              </Form.Label>
              <Form.Control
                type="file"
                name="logFileName"
                className="custom-file-input"
                id="csvGoPrLogFileName"
                aria-describedby="inputFile"
                onChange={loadCSVGoProFile}
                onFocus={() => toggleButtonSwitch()}
              />
            </InputGroup>
          </Form.Group>
        )}
      </>
    );
  }
  return '';
};

VideoGoProLogFileField.propTypes = {
  coordinatesDataType: PropTypes.string.isRequired,
  logFileName: PropTypes.string.isRequired,
  loadCSVGoProFile: PropTypes.func.isRequired,
  toggleButtonSwitch: PropTypes.func.isRequired,
  isAutoLoadData: PropTypes.bool.isRequired
};

export default VideoGoProLogFileField;
